export const rowsEngg = [
  {
    SNo: 1,
    CollegeCode: "34",
    CollegeName: "GMR Institute of Technology, Rajam",
    District: "SKL",
    "College Type": "Engineering",
    wURL: "http://www.gmrit.org/",
  },
  {
    SNo: 2,
    CollegeCode: "A5",
    CollegeName: "Aditya Inst of Tech & Manag, Tekkali",
    District: "SKL",
    "College Type": "Engineering",
    wURL: "https://www.adityatekkali.edu.in/",
  },
  {
    SNo: 3,
    CollegeCode: "33",
    CollegeName: "MVGR College of Engineering, Chinthalavalasa.",
    District: "VZM",
    "College Type": "Engineering",
    wURL: "https://www.mvgrce.com/",
  },
  {
    SNo: 4,
    CollegeCode: "KD",
    CollegeName: "Lendi Institute of Engineering & Technology, Denkada",
    District: "VZM",
    "College Type": "Engineering",
    wURL: "https://www.lendi.org/",
  },
  {
    SNo: 5,
    CollegeCode: "98",
    CollegeName: "Raghu Engineering College, Bheemili",
    District: "VSP",
    "College Type": "Engineering",
    wURL: "https://raghuenggcollege.com/",
  },
  {
    SNo: 6,
    CollegeCode: "L3",
    CollegeName: "Vignans Institute of Information Technology, Gajuwaka",
    District: "VSP",
    "College Type": "Engineering",
    wURL: "https://vignaniit.edu.in/",
  },
  {
    SNo: 7,
    CollegeCode: "NU",
    CollegeName: "Nadimpalli Satyanarayana Raju Institute of Technology, Sontyam",
    District: "VSP",
    "College Type": "Engineering",
    wURL: "http://www.nsrit.edu.in/",
  },
  {
    SNo: 8,
    CollegeCode: "3J",
    CollegeName: "Raghu Institute of Technology, Dakammari, Bheemunipatnam Mandal, Visakhapatnam District",
    District: "VSP",
    "College Type": "Engineering",
    wURL: "https://www.raghuinsttech.com/",
  },
 
  {
    SNo: 9,
    CollegeCode: "Q7",
    CollegeName: "Avanthi Institute of Engineering & Technology, Bhogapuram",
    District: "VZM",
    "College Type": "Engineering",
    wURL: "http://aietta.ac.in/",
  },
    

];
